import React from 'react'
import styled from 'styled-components'
import { Col, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import Nokia from '../../assets/nokia.png'
import Ufrn from '../../assets/ufrn.png'
import GoStack from '../../assets/gostack.png'


const { Paragraph } = Typography;

const EducationList = (props) => {

    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
        ];

    const {t} = useTranslation()
    
    const works = [
        {
            id: 1,
            title: 'Fundação Nokia de Ensino',
            location: 'Manaus, Amazonas',
            currently: false,
            img: Nokia,
            start: new Date(2013, 0, 1),
            end: new Date(2015, 11, 30),
            description: 'Formação de técnico em Mecatrônica. Durante o ensino médio, estudei matérias relacionadas a área de programação, pneumática, microcontroladores, eletrônica, ferramentaria dentre outras.'
        },
        {
            id: 2,
            title: 'Universidade Federal do Rio Grande do Norte',
            location: 'Natal, Rio Grande do Norte',
            currently: true,
            img: Ufrn,
            start: new Date(2016, 1, 1),
            end: new Date(),
            description:  'Formação de Bacharelado em Tecnologia da Informação. Durante o período da faculdade, tive contato com Estruturação de Dados, Programação Frontend e Backend, Boas Práticas de Programação, Fundamentos de Jogos Digitais, Programação Funcional, Desenvolvimento para Dispositivos Móveis, Internet das Coisas (IoT), dentre outras. Me envolvi com um projeto de pesquisa onde desenvolvi uma Plataforma Educacional, apresentada na Engineering in Medicine and Biology Conference (EMBC2019), sediada em Berlim.',
        },
        {
            id: 3,
            title: 'Rocketseat Gostack Bootcamp',
            location: 'Online',
            currently: true,
            img: GoStack,
            start: new Date(2020, 5, 15),
            end: new Date(),
            description: 'Formação como Desenvolvedor FullStack. Curso pratico e intensivo usando uma stack centralizada no NodeJS, ReactJS e ReactNative, contruindo aplicaçoes do zero até o deploy online da mesma usando testes automatizados, integração contínua e muitas bibliotecas importantes assim como ferramentas e frameworks em projetos voltados a problemas reais do dia a dia.',
        },
    ]
    
    return (
        <>
            {works.map(item => {
                return (
                    <>
                        {item.id <= props.displayed && <Col xs={24} sm={24} md={12} lg={props.col} xl={props.col} key={item.id} style={{lineHeight: '1.5rem', padding: '30px 20px', textAlign: 'center'}}>
                            <Img src={item.img} />
                            <H3>{item.title}</H3>
                            <Small>{item.location}</Small><br />
                             {/* eslint-disable-next-line */}
                            <Small>{`${months[item.start.getMonth()]} ` + `${item.start.getFullYear()}`} - {item.currently ? `${t('Presente')}` : `${months[item.end.getMonth()]} ` + `${item.end.getFullYear()}`}</Small>
                            <Paragraph ellipsis={{rows: 2, expandable: true}}>
                                {item.description}
                            </Paragraph>
                        </Col>}
                    </>
                )
            })}
        </>
    )
}


export default EducationList

const Img = styled.img`
    margin-bottom: 20px;
    width: 150px;
    height: 150px;
`

const H3 = styled.h3`
    margin: 0;
    padding: 0;
    font-size: 18px;
`

const Small = styled.small`
    margin: 0;
    padding: 0;
`